import { css, type Theme } from "@emotion/react";

export const searchBar = css`
  & > div:first-of-type {
    padding-right: 0;
  }
`;

export const noResultsFound = css`
  margin: 1rem;
  text-align: center;
`;

export const skeleton = css`
  &:first-of-type {
    margin-top: 0;
  }
`;

export const checkbox = css`
  padding: 0.25rem 0.5rem;

  > label:first-of-type {
    align-items: baseline;

    > div:last-of-type {
      display: inline-block;
      flex: 1 1 0px;
    }
  }
`;

export const checkboxFocused = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMuted};
`;

export const dropdownContent = css`
  & > div:first-of-type > div:first-of-type {
    max-height: 13rem;
    padding: 0;
  }
`;

export const activeSearchLoading = css`
  margin-bottom: 9rem;
`;

export const activeSearchNoResults = css`
  margin-bottom: 9rem;
`;

export const activeSearchOneResult = css`
  margin-bottom: 2rem;
`;

export const activeSearchTwoResults = css`
  margin-bottom: 4rem;
`;

export const activeSearchThreeResults = css`
  margin-bottom: 6rem;
`;

export const activeSearchFourResults = css`
  margin-bottom: 8rem;
`;

export const activeSearchFiveResults = css`
  margin-bottom: 10rem;
`;

export const activeSearchSixResults = css`
  margin-bottom: 12rem;
`;
